// termine.start_datum/end_datum sind timestamptz — gespeichert wird ein echter
// Zeitpunkt. Eingabe/Anzeige laufen in lokaler Wanduhrzeit (Europe/Berlin beim
// Nutzer); diese Helfer übersetzen dazwischen. Ohne sie landet die Wanduhrzeit
// als UTC in der DB und die Anzeige verschiebt um +1/+2h.

/** 'YYYY-MM-DD' + 'HH:MM' (lokale Wanduhrzeit) → ISO-Instant ('…Z'). */
export function lokalZuIso(datum: string, zeit: string): string {
  return new Date(`${datum}T${zeit}:00`).toISOString();
}

/** ISO-/timestamptz-String → lokales Datum 'YYYY-MM-DD'. */
export function isoZuLokalDatum(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** ISO-/timestamptz-String → lokale Uhrzeit 'HH:MM'. */
export function isoZuLokalZeit(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/** Lokale Tagesgrenzen (00:00–23:59:59.999) als ISO-Instants — für timestamptz-Vergleiche. */
export function lokalerTagesbereich(datum: Date = new Date()): { startIso: string; endeIso: string } {
  const start = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate(), 0, 0, 0, 0);
  const ende = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate(), 23, 59, 59, 999);
  return { startIso: start.toISOString(), endeIso: ende.toISOString() };
}
